import {
  ShipmentDocument,
  ShipmentDocumentItem,
} from './shipment-document.model';

export interface Requisition {
  requisitionId?: string;
  requestedDate?: string | Date;
  requestedBy?: string;
  requestStatus?: string;
  requisitionNumber?: number;
  neededBy?: string | Date;
  notes?: string;
  facilityId?: number;
  requisitionItems: RequisitionItem[];
}

export interface RequisitionItem {
  requisitionItemId?: string;
  shipmentDocumentItemId?: string;
  requisitionId?: string;
  itemId: string;
  quantityRequested: number;
  notes?: string;
  shipmentDocument?: ShipmentDocument;
  shipmentDocumentItem?: ShipmentDocumentItem;
  requisitionNotes?: string[];
}

export interface RequisitionStatus {
  requisitionStatusId: string;
  requisitionStatusName: string;
  description: string;
  statusOrder: number;
}
